import { STATIC_FILTER_INPUTS } from '@/hooks/FilterModal/filterModal.gql';
import {
  getFilterInput,
  getFiltersFromSearch
} from "@/hooks/FilterModal/helpers"
import { useSearchParams } from "next/navigation"
import { useMemo } from "react"

export const useGetFilterInput = () => {
  const introspectionData = STATIC_FILTER_INPUTS;
  const searchParams = useSearchParams()

  const filterTypeMap = useMemo(() => {
    const typeMap = new Map()
    introspectionData.__type.inputFields.forEach(({ name, type }: { name: string; type: { name: string } }) => {
      typeMap.set(name, type.name)
    })
    return typeMap
  }, [])

  const newFilters = useMemo(() => {
    const filtersObj: any = {}
    const filters = getFiltersFromSearch(searchParams)
    filters.forEach((values, key) => {
      const filterMapType = filterTypeMap.get(key)
      filtersObj[key] = getFilterInput(values, filterMapType)
    })
    return filtersObj
  }, [filterTypeMap, searchParams])

  return {
    introspectionCalled: true,
    introspectionData,
    introspectionLoading: false,
    newFilters
  }
}
